import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { FieldState } from '@angular/forms/signals';

@Component({
  selector: 'homi-form-extra-errors',
  templateUrl: 'form-extra-errors.component.html',
  styleUrls: ['form-extra-errors.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormExtraErrorsComponent {
  public readonly form: InputSignal<FieldState<unknown>> = input.required();
}
